import React, { ReactNode, useEffect, useRef, useState } from "react";
import MaxContainer from "../../../../components/Container/MaxContainer";
import { useParams } from "react-router-dom";
import { getSingleProjectDetails } from "../../../../services/customer/project";
// import Loader from "../../../../components/Loader";
import { AWS_BASE_URL, DOMAIN_URL } from "../../../../clientConfig";
import "../../../../assets/scss/property-information.scss";
import SharedModel from "../../../../components/Share/SharedModel";
import CustomerReport from "../../../../components/Section/Report/CustomerReport";
import SeeAllImageModal from "../../Property/Modal/SeeAllImageModal";
import ProjectDetailSection from "./Section/ProjectDetailSection";
// import FacilitiesSection from "../../../../components/Section/CommonInformation/FacilitiesSection";
import FloorPlanSection from "./Section/FloorPlanSection";
import SimilarProjectSection from "./Section/SimilarProjectSection";
import FactFeatureSection from "./Section/FactFeatureSection";
import CustomerAuthModal from "../../../../components/Modal/Customer/Auth/CustomerAuthModal";
import { contactUsForProperty } from "../../../../services/customer/property";
import { PROJECT_INFO_MENULIST } from "../../../../constants";
import PropertyInProject from "./Section/PropertyInProject";
import InfoMenuSection from "../../../../components/Section/CommonInformation/MenuSection";
import AmenitiesSection from "../../../../components/Section/CommonInformation/AmenitiesSection";
import StorySection from "../../../../components/Section/CommonInformation/StorySection";
import ProjectLocationSection from "../../../../components/Section/CommonInformation/LocationSection";
import GridImageSection from "../../../../components/Section/CommonInformation/GridImages";
import Tooltip from "../../../../components/Tooltip";
import { formatPrice, groupBy } from "../../../../utils";
import RightSideSection from "./Section/RightSideSection";
import MediaSection from "./Section/MediaSection";
import Meta from "../../../../components/Meta/Meta";
import ProjectHeaderSection from "./Section/ProjectHeaderSection";
import { USER_ROUTES } from "../../../../constants/appRoutes";
import BackButton from "../../../../components/BackButton";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers/allReducers";
import BtnContactAgent from "../../../../components/Section/ContactAnAgent";
import ProjectShareBtn from "../../../../components/Section/CommonInformation/ShareBtn";

type BuildingMapType = {
  key: string;
  type: number;
  min_outer: number;
  max_outer: number;
  subCategoryId: string;
};

const ProjectInformationPage = ({ serverProps }: any) => {
  const topToSection = 120;
  const { projectId, slug } = useParams();
  const userinfo = useSelector((state: RootState) => state.user);

  const handleFetch = useRef<boolean>(false);
  const [seeImageModalShow, setSeeImageModalShow] = useState<boolean>(false);
  const [sharedModalShow, setSharedModalShow] = useState(false);
  const [reportModalShow, setReportModalShow] = useState(false);
  const [isFullScreenMedia, setIsFullScreenMedia] = useState(false);

  // const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState<any>(
    serverProps?.projectDetails ?? null
  );

  const [projectImages, setProjectImages] = useState<any[]>([]);
  const [floorPlansImageList, setFloorPlansImageList] = useState<any[]>([]);
  const [groupFloorList, setGroupFloorList] = useState<any[]>([]);
  const [authModal, setAuthModal] = useState<boolean>(false);
  const [alreadyRequestTour, setAlreadyRequestTour] = useState();
  const [basePrice, setBasePrice] = useState(0);
  const [floorPlanList, setFloorPlanList] = useState<{
    open: boolean;
    index: null | number;
  }>({
    open: false,
    index: null,
  });

  const [menuList, setMenuList] = useState(PROJECT_INFO_MENULIST);

  const handleLoading = (_: boolean) => {
    // setLoading(isLoading);
  };

  const handlePropertyMenuList = (data: any) => {
    const updatedProjectMenuList = PROJECT_INFO_MENULIST.map((item) => {
      let isActive = true;
      let label = item.label;

      if (item.hrefId === "amenities" && !data?.amenities?.length)
        isActive = false;
      else if (
        item.hrefId === "fact-features" &&
        !data?.fact_and_features?.length
      )
        isActive = false;
      else if (
        item.hrefId === "media_about" &&
        (!data?.description?.length || !data?.video_link?.length)
      ) {
        isActive = false;
      }

      if (item.hrefId === "media_about") {
        if (data?.description?.length && data?.video_link?.length) {
          isActive = true;
          label = "About & Media";
        } else if (data?.description?.length) {
          isActive = true;
          label = "About";
        } else if (data?.video_link?.length) {
          isActive = true;
          label = "Media";
        } else {
          isActive = false;
        }
      }

      return {
        ...item,
        label,
        active: isActive,
      };
    });

    setMenuList(updatedProjectMenuList);
  };

  const handleFloorGroup = (buildings: any) => {
    const groupValue = groupBy(buildings, [
      (item: any) =>
        item?.building_type === 0 ? "Commercial" : `${item?.building_type} BHK`,
      (item: any) => item?.sub_category,
    ]);

    const convertArray = Object.keys(groupValue)?.map((key: string) => ({
      building: key,
      list: groupValue[key],
    }));

    return convertArray;
  };

  const handleApiResponse = (data: any) => {
    handlePropertyMenuList(data);
    setAlreadyRequestTour(data?.meeting_status);
    const prices = data?.buildings
      ?.map((building: any) => building?.building_expected_price)
      ?.filter((item: any) => item !== 0);
    if (prices?.length) {
      const minPrice = Math.min(...prices);
      setBasePrice(minPrice);
    }

    const groupFloorList = handleFloorGroup(data?.buildings ?? []);
    setGroupFloorList(
      groupFloorList?.sort(
        (a: any, b: any) =>
          a?.building?.split(" ")?.[0] - b?.building?.split(" ")?.[0]
      )
    );

    setFloorPlansImageList(
      groupFloorList
        ?.sort(
          (a: any, b: any) =>
            a?.building?.split(" ")?.[0] - b?.building?.split(" ")?.[0]
        )
        ?.map((item) => ({
          ...item,
          list: item?.list?.map((unit: any) => ({
            ...unit,
            building_floor_plan: unit?.building_floor_plan?.sort(
              (a: any, b: any) => a?.label?.localeCompare(b?.label)
            ),
          })),
        }))
        ?.map((item) => item?.list)
        ?.flat(1)
        ?.map((item) => item?.building_floor_plan)
        ?.flat(1)
    );
    setProjectImages(data?.project_images?.images);
    handleLoading(false);
    setProjectData(data);
  };

  const handleModalAuthClose = () => {
    setAuthModal(false);
  };

  const handleModalAuthOpen = () => {
    setAuthModal(true);
  };

  useEffect(() => {
    if (projectId && !handleFetch.current) {
      handleLoading(true);
      getSingleProjectDetails(projectId, handleApiResponse, handleLoading);
      handleFetch.current = true;
    }
  }, [projectId]);

  const [currentSection, setCurrentSection] = useState("overview");

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = document.querySelectorAll("section");
      let current = "overview";

      sectionElements.forEach((section) => {
        const sectionTop = section?.offsetTop;
        if (window?.scrollY + 1 >= sectionTop - topToSection) {
          current = section?.getAttribute("id") ?? "";
        }
      });

      setCurrentSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section?.offsetTop - topToSection,
        behavior: "instant",
      });
    }
  };

  const handleDownloadBrochureEnquire = async () => {
    const apiData = {
      project_id: projectId,
      full_name: userinfo?.userInfo?.full_name,
      email: userinfo?.userInfo?.email?.toLowerCase(),
      contact_number: userinfo?.userInfo?.contact_number,
      message: "Downloaded brochure.",
      is_download: true,
    };

    contactUsForProperty(apiData, handleLoading, () => {});
  };

  const handleGetShowPrice = (data: any): string => {
    const prices = data?.buildings
      ?.map((building: any) => building?.building_expected_price)
      .filter((item: any) => item !== 0);

    if (prices?.length >= 2) {
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      return `₹ ${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;
    } else if (prices?.length >= 1) {
      return `₹ ${formatPrice(prices?.[0])}`;
    } else return "";
  };

  function filterUniqueBuildingTypes(
    data: any[],
    maxCount: number | "all" = "all"
  ): { building_type: number }[] {
    if (!Array.isArray(data)) return [];

    const buildingMap = new Map<string, BuildingMapType>();

    for (const item of data) {
      const area =
        item?.building_type === 0
          ? item?.building_interior_area
          : item?.building_outer_area;
      const key = `${item?.building_type}-${item?.sub_category}`;
      const existing = buildingMap.get(key);

      if (existing) {
        existing.min_outer = Math.min(existing?.min_outer, area);
        existing.max_outer = Math.max(existing?.max_outer, area);
      } else {
        buildingMap.set(key, {
          key: key,
          type: item?.building_type,
          min_outer: area,
          max_outer: area,
          subCategoryId: item?.sub_category_id,
        });
      }
    }

    const getMinMaxAreaList = Array.from(buildingMap?.values());

    const seenBuildingTypes = new Set<string>();
    const result: { building_type: number }[] = [];

    for (const item of data) {
      const key = `${item?.building_type}-${item?.sub_category}`;
      if (!seenBuildingTypes.has(key)) {
        const minMaxdata = getMinMaxAreaList?.find(
          (data) =>
            data?.type === item.building_type &&
            data?.subCategoryId === item?.sub_category_id
        );
        result?.push({ ...item, ...minMaxdata });
        seenBuildingTypes.add(key);
      }
      if (typeof maxCount === "number" && result?.length >= maxCount) break;
    }

    const sortingBuilding = result?.sort((a, b) => {
      if (a.building_type === 0) return 1;
      if (b.building_type === 0) return -1;
      return a.building_type - b.building_type;
    });

    return sortingBuilding;
  }

  useEffect(() => {
    if (projectData?.slug && slug !== projectData?.slug) {
      window.history.replaceState(
        null,
        "",
        `${USER_ROUTES.PROJECT_INFORMATION}/${projectData?.slug}/${projectId}`
      );
    }
  }, [projectData?.slug]);

  const headerRef = useRef<HTMLSelectElement | null>(null);

  useEffect(() => {
    if (document) {
      const body = document.body;
      if (seeImageModalShow) {
        body.style.overflowY = "hidden";
        (body.style as any)["-webkit-overflow-scrolling"] = "touch";
      } else {
        body.style.overflowY = "";
        (body.style as any)["-webkit-overflow-scrolling"] = "";
      }
    }
  }, [seeImageModalShow]);

  return (
    <MaxContainer className="!p-1 md:p-4 !max-w-[110rem] project-information">
      {/* {loading ? (
        <Loader />
      ) : ( */}
      <>
        <Meta
          title={
            projectData?.seo_title
              ? `${projectData?.seo_title ?? ""} | Savitar Realty`
              : "Savitar Realty"
          }
          description={projectData?.seo_description}
          keywords={projectData?.seo_keywords}
          ogUrl={typeof window !== "undefined" ? location?.href : ""}
          ogImage={`${AWS_BASE_URL}${projectData?.project_images?.images?.[0]?.image}`}
        />
        <div className="relative">
          <div className="top-6 left-3 z-[999] absolute">
            <BackButton />
          </div>
          <div className="xs:py-4 pt-3 project-information">
            {projectData && (
              <GridImageSection
                ImagesList={projectImages}
                floorPlansList={floorPlansImageList}
                handleSeeImageClick={() => setSeeImageModalShow(true)}
                iframe={projectData?.iframe}
                projectData={projectData}
                mediaOpen={isFullScreenMedia}
                setMediaOpen={setIsFullScreenMedia}
                floorPlan={{
                  floorIndex: floorPlanList.index,
                  open: floorPlanList.open,
                  close: () =>
                    setFloorPlanList({
                      index: null,
                      open: false,
                    }),
                }}
                handleOpenAuthModel={handleModalAuthOpen}
                setSharedModalShow={setSharedModalShow}
                setReportModalShow={setReportModalShow}
                type="PROJECT"
              />
            )}
          </div>

          <InfoMenuSection
            activeMenu={currentSection}
            handleClickAction={handleScrollToSection}
            menuList={menuList}
            headerRef={headerRef}
            headerContent={
              <div className="flex justify-between items-center py-2">
                <div className="flex items-center gap-2">
                  <div className="lg:hidden">
                    <BackButton />
                  </div>
                  <h2 className="w-full max-w-60 font-bold text-lg lg:text-2xl line-clamp-1">
                    {projectData?.name}
                  </h2>
                </div>
                <ProjectShareBtn
                  setSharedModalShow={setSharedModalShow}
                  setReportModalShow={setReportModalShow}
                  type="PROJECT"
                  projectData={projectData}
                  handleOpenAuthModel={handleModalAuthOpen}
                />
              </div>
            }
          />

          <div className="px-2">
            <section id="overview" ref={headerRef}>
              {projectData && (
                <ProjectHeaderSection
                  projectData={projectData}
                  setAlreadyRequestTour={setAlreadyRequestTour}
                  alreadyRequestTour={alreadyRequestTour}
                />
              )}
              <ProjectDetailSection
                authModel={handleModalAuthOpen}
                enquiryCreate={handleDownloadBrochureEnquire}
                projectData={projectData}
                filterUniqueBuildingTypes={filterUniqueBuildingTypes}
              />
            </section>

            <div className="gap-8 small:grid grid-cols-12 py-6 xs:py-10">
              <div className="space-y-8 col-span-12 lg:col-span-8">
                <section id="media_about">
                  <div className="flex-1 xs:mb-4">
                    <h2 className="font-normal text-dark-cyan text-3xl md:text-4xl text-center">
                      <span className="font-black">{`${projectData?.description ? "About" : ""} ${projectData?.description && projectData?.video_link?.length ? "&" : ""} ${projectData?.video_link?.length ? "Media" : ""}`}</span>
                    </h2>
                  </div>
                  {projectData?.video_link ? (
                    <MediaSection
                      projectData={projectData}
                      setOpenMediaScreen={setIsFullScreenMedia}
                    />
                  ) : null}
                  {projectData?.description ? (
                    <StorySection
                      projectData={projectData}
                      focusSection={handleScrollToSection}
                    />
                  ) : null}
                </section>
                {projectData?.amenities?.length ? (
                  <AmenitiesSection
                    projectData={projectData}
                    handleClickView={handleScrollToSection}
                  />
                ) : null}
                {projectData?.fact_and_features?.length ? (
                  <FactFeatureSection
                    factAndFeatures={projectData?.fact_and_features}
                  />
                ) : null}
                {projectData?.buildings?.length ? (
                  <FloorPlanSection
                    projectData={projectData}
                    floorList={groupFloorList}
                    imageClick={(index: number) =>
                      setFloorPlanList({
                        index: index,
                        open: true,
                      })
                    }
                  />
                ) : null}

                {/* <FacilitiesSection projectData={projectData} /> */}
              </div>
              <div className="col-span-12 lg:col-span-4">
                {projectData && (
                  <RightSideSection
                    authModel={handleModalAuthOpen}
                    enquiryCreate={handleDownloadBrochureEnquire}
                    projectData={projectData}
                    alreadyRequestTour={alreadyRequestTour}
                    setAlreadyRequestTour={setAlreadyRequestTour}
                    basePrice={basePrice}
                  />
                )}
              </div>
            </div>

            <ProjectLocationSection
              lat={projectData?.lat}
              long={projectData?.long}
              facilities={projectData?.facilities}
              view_count={projectData?.view_count}
              created_at={projectData?.created_at}
              updated_at={projectData?.updated_at}
            />
          </div>
        </div>
        <hr className="h-4" />
      </>
      {/* ) */}
      {/* } */}

      <PropertyInProject
        projectId={projectId}
        handleModalAuthOpen={() => {
          setAuthModal(true);
        }}
        handleDropdownActions={(item: any) => {
          if (item?.key === "share") {
            setSharedModalShow(true);
          } else if (item?.key === "report") {
            setReportModalShow(true);
          }
        }}
      />

      {projectData?.category_id && (
        <SimilarProjectSection
          category_id={projectData?.category_id}
          handleDataRef={handleFetch}
          handleModalAuthOpen={handleModalAuthOpen}
        />
      )}

      <SeeAllImageModal
        modalShow={seeImageModalShow}
        closeModal={() => setSeeImageModalShow(false)}
        imageList={projectImages}
        iframe={projectData?.iframe}
        floorPlansList={floorPlansImageList}
        propertyData={projectData}
        rightSideContainer={RightSideContainer({
          price:
            handleGetShowPrice(projectData) !== "" ? (
              handleGetShowPrice(projectData)
            ) : (
              <BtnContactAgent
                className={`h-fit w-max lg:w-max pb-1 pt-0 px-3 font-medium`}
                initialData={{
                  project_id: projectData?._id,
                }}
              >
                Price on Request
              </BtnContactAgent>
            ),
          address: projectData?.location,
          name: projectData?.name,
          shortFeature: filterUniqueBuildingTypes(
            projectData?.buildings,
            4
          )?.map((item: any) => ({
            title: (
              <div className="flex justify-between items-center gap-x-6">
                <h2>
                  {item?.building_type === 0
                    ? "Commercial"
                    : `${item?.building_type} BHK`}
                </h2>
                {item?.building_expected_price !== 0 ? (
                  <h4>₹ {formatPrice(item?.building_expected_price)}</h4>
                ) : null}
                <h6>{item?.building_interior_area} Sq-ft</h6>
              </div>
            ),
            tooltip: false,
          })),
        })}
      />

      <SharedModel
        showModal={sharedModalShow}
        closeModal={() => setSharedModalShow(false)}
        shareLink={`${DOMAIN_URL}project-information/${projectData?.slug}/${projectId}`}
      />

      <CustomerReport
        initialData={{ project_id: projectId }}
        closeModal={() => setReportModalShow(false)}
        showModal={reportModalShow}
      />

      <CustomerAuthModal
        modalShow={authModal}
        closeModal={handleModalAuthClose}
      />
    </MaxContainer>
  );
};

export default ProjectInformationPage;

interface RightSideContainerProps {
  price: string | ReactNode;
  name: string;
  address: string;
  shortFeature: {
    title: any;
    tooltip: string | false;
  }[];
}

const RightSideContainer: React.FC<RightSideContainerProps> = ({
  price,
  name,
  address,
  shortFeature,
}) => {
  return (
    <div className="flex justify-between items-start gap-x-6 px-3 pb-4">
      <div className="space-y-2 mb-2">
        <h1 className="font-medium text-xl">{name}</h1>
        {typeof price === "string" ? (
          <h2 className="font-bold text-2xl">{price}</h2>
        ) : (
          price
        )}
        <p className="text-base">{address}</p>
      </div>
      <div className="divide-y divide-black min-w-fit">
        {shortFeature.map((item, index) => (
          <div className="px-4 py-2" key={index}>
            <Tooltip
              hideTooltip={item?.tooltip !== false}
              message={item?.tooltip}
            >
              <div>{item.title}</div>
            </Tooltip>
          </div>
        ))}
      </div>
    </div>
  );
};
